import { useCallback, useRef, useState } from 'react';

type UseVisibilityOptions = {
  rootMargin?: string;
  threshold?: number;
};

export const useVisibility = ({ rootMargin = '200px', threshold = 0 }: UseVisibilityOptions = {}) => {
  const [isVisible, setIsVisible] = useState(false);
  const observerRef = useRef<IntersectionObserver | null>(null);

  const ref = useCallback(
    (node: HTMLElement | null) => {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }

      if (!node) return;

      observerRef.current = new IntersectionObserver(
        ([entry]) => {
          setIsVisible(entry.isIntersecting);
        },
        { rootMargin, threshold },
      );

      observerRef.current.observe(node);
    },
    [rootMargin, threshold],
  );

  return { ref, isVisible };
};
